import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/games/`;

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        console.error('No se encontró un token válido.');
        throw new Error('Usuario no autenticado');
    }
    return { Authorization: `Bearer ${token}` };
};

const handleError = (error) => {
    if (error.response?.data?.message === 'Invalid token') {
        console.error('Token inválido. Eliminando token de localStorage.');
        localStorage.removeItem('token'); // Eliminar el token inválido
        throw new Error('Token inválido. Por favor, inicie sesión nuevamente.');
    } else {
        console.error(error.response?.data || error.message);
        throw error;
    }
};

const normalizeGameError = (e) => {
  const status = e?.response?.status;
  const msg = e?.response?.data?.error || e?.message || 'Unexpected error';
  if (status === 403) {
    const err = new Error(msg);
    err.code = 'GAME_UNAVAILABLE';
    err.status = 403;
    throw err;
  }
  throw (e?.response?.data || e);
};

// todas las sesiones de juego
export const getGameSessions = async () => {
    try {
        const headers = getAuthHeaders();
        const response = await axios.get(`${API_URL}sessions`, { headers });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Añadir un juego a una sesión
export const addGameToSession = async (gameData) => {
    try {
        const headers = getAuthHeaders();
        const response = await axios.post(`${API_URL}add-game`, gameData, { headers });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const getAllSessionsWithGames = async () => {
    try {
        const headers = getAuthHeaders();
        const response = await axios.get(`${API_URL}sessions`, { headers });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// juegos

// 1 dado
export const playMenelDie = async (betAmount, chosenNumber) => {
    try {
        const headers = getAuthHeaders();
        const response = await axios.post(`${API_URL}play-menel-die`, { betAmount, chosenNumber }, { headers });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// dado 2
export const playMenelTwoDice = async (betAmount, chosenNumber) => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.post(`${API_URL}play-menel-two-dice`, { betAmount, chosenNumber }, { headers });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

/////// playMenelDuelDice////////////////
export const playMenelDuelDice = async (betAmount, strategy) => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.post(`${API_URL}play-menel-duel-dice`, { betAmount, strategy }, { headers });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
/////// playMenelDuelDice////////////////

// historial del jugador para "1 MENEL Die"
export const getPlayerHistory = async (userId, gameId = 1) => {
    try {
        const headers = getAuthHeaders();
        const response = await axios.get(`${API_URL}history`, {
            headers,
            params: { userId, gameId },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const playBullfighterOrBull = async (betAmount, chosenSide) => {
    try {
      const headers = getAuthHeaders();
      const response = await axios.post(`${API_URL}bullfighter-or-bull`, { betAmount, chosenSide }, { headers });
      return response.data;
    } catch (error) {
      handleError(error);
    }
};


//////////////////// Black Jack ////////////////////
//////////////////// Black Jack ////////////////////

export const playBlackJack = async (betAmount) => {
  try {
    const headers = getAuthHeaders();
    const { data } = await axios.post(`${API_URL}blackjack/play`, { betAmount }, { headers });
    return data;
  } catch (error) {
    if (error?.response?.data?.error === 'Insufficient balance') {
      throw new Error('Insufficient balance.');
    }
    throw (error?.response?.data || error);
  }
};
export const hitBlackJack = async () => {
  const headers = getAuthHeaders();
  try {
    const { data } = await axios.post(`${API_URL}blackjack/hit`, {}, { headers });
    return data;
  } catch (e) {
    if (e?.response?.status === 409) {
      const err = new Error(e.response?.data?.error || 'No open round.');
      err.code = 'NO_OPEN_ROUND';
      throw err;
    }
    throw (e.response?.data || e);
  }
};
export const standBlackJack = async () => {
  const headers = getAuthHeaders();
  try {
    const { data } = await axios.post(`${API_URL}blackjack/stand`, {}, { headers });
    return data;
  } catch (e) {
    if (e?.response?.status === 409) {
      const err = new Error(e.response?.data?.error || 'No open round.');
      err.code = 'NO_OPEN_ROUND';
      throw err;
    }
    throw (e.response?.data || e);
  }
};
export const getBlackJackHistory = async () => {
  const headers = getAuthHeaders();
  const { data } = await axios.get(`${API_URL}blackjack/history`, { headers });
  return data;
};
// Abortar ronda abierta (refund opcional; por defecto false)
export const resumeBlackJack = async () => {
  try {
    const headers = getAuthHeaders();
    const res = await axios.get(`${API_URL}blackjack/resume`, { headers });
    return res.data;
  } catch (e) {
    if (e?.response?.status === 204) return null;
    handleError(e);
  }
};
export const abortBlackJack = async (refund = false) => {
  try {
    const headers = getAuthHeaders();
    const res = await axios.post(`${API_URL}blackjack/abort`, { refund }, { headers });
    console.log('[abortBlackJack] status=', res.status, 'data=', res.data);
    return res.data;
  } catch (e) {
    handleError(e);
  }
};
//////////////////// Black Jack ////////////////////
//////////////////// Black Jack ////////////////////

//////////////////////////////////////////////////////// European BlackJack ///////////////////////////////////////////////////////////////
// European Blackjack
export const playEuropeanBlackJack = async (betAmount) => {
  try {
    const headers = getAuthHeaders();
    const { data } = await axios.post(`${API_URL}european-blackjack/play`, { betAmount }, { headers });
    return data;
  } catch (e) { normalizeGameError(e); }
};
export const hitEuropeanBlackJack = async () => {
  try {
    const headers = getAuthHeaders();
    const { data } = await axios.post(`${API_URL}european-blackjack/hit`, {}, { headers });
    return data;
  } catch (e) { normalizeGameError(e); }
};
export const standEuropeanBlackJack = async () => {
  try {
    const headers = getAuthHeaders();
    const { data } = await axios.post(`${API_URL}european-blackjack/stand`, {}, { headers });
    return data;
  } catch (e) { normalizeGameError(e); }
};
export const resumeEuropeanBlackJack = async () => {
  try {
    const headers = getAuthHeaders();
    const res = await axios.get(`${API_URL}european-blackjack/resume`, { headers });
    return res.data;
  } catch (e) {
    if (e?.response?.status === 204) return null;
    normalizeGameError(e);
  }
};
export const abortEuropeanBlackJack = async (refund = false) => {
  try {
    const headers = getAuthHeaders();
    const { data } = await axios.post(`${API_URL}european-blackjack/abort`, { refund }, { headers });
    return data;
  } catch (e) { normalizeGameError(e); }
};
export const getEuropeanBlackJackHistory = async () => {
  const headers = getAuthHeaders();
  const { data } = await axios.get(`${API_URL}european-blackjack/history`, { headers });
  return data;
};
//////////////////////////////////////////////////////// European BlackJack ///////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////// Blackjack Switch ///////////////////////////////////////////////////////////////
export const playBlackJackSwitch = async (betAmount) => {
  try {
    const headers = getAuthHeaders();
    const { data } = await axios.post(`${API_URL}blackjack-switch/play`, { betAmount }, { headers });
    return data;
  } catch (e) { normalizeGameError(e); }
};

export const switchBlackJackSwitch = async () => {
  try {
    const headers = getAuthHeaders();
    const { data } = await axios.post(`${API_URL}blackjack-switch/switch`, {}, { headers });
    return data;
  } catch (e) { normalizeGameError(e); }
};

export const hitBlackJackSwitch = async () => {
  try {
    const headers = getAuthHeaders();
    const { data } = await axios.post(`${API_URL}blackjack-switch/hit`, {}, { headers });
    return data;
  } catch (e) { normalizeGameError(e); }
};

export const standBlackJackSwitch = async () => {
  try {
    const headers = getAuthHeaders();
    const { data } = await axios.post(`${API_URL}blackjack-switch/stand`, {}, { headers });
    return data;
  } catch (e) { normalizeGameError(e); }
};

export const resumeBlackJackSwitch = async () => {
  const headers = getAuthHeaders();
  try {
    const res = await axios.get(`${API_URL}blackjack-switch/resume`, { headers });
    return res.data;
  } catch (e) { if (e?.response?.status === 204) return null; normalizeGameError(e); }
};

export const abortBlackJackSwitch = async (refund = false) => {
  const headers = getAuthHeaders();
  const { data } = await axios.post(`${API_URL}blackjack-switch/abort`, { refund }, { headers });
  return data;
};

export const getBlackJackSwitchHistory = async () => {
  const headers = getAuthHeaders();
  const { data } = await axios.get(`${API_URL}blackjack-switch/history`, { headers });
  return data;
};
//////////////////////////////////////////////////////// Blackjack Switch ///////////////////////////////////////////////////////////////

//////////////////// Baccarat ////////////////////
export const playBaccarat = async (betAmount, betSide) => {
    try {
        const headers = getAuthHeaders();
        const response = await axios.post(`${API_URL}baccarat/play`, { betAmount, betSide }, { headers });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getBaccaratHistory = async (userId) => {
    try {
        const headers = getAuthHeaders();
        const response = await axios.get(`${API_URL}baccarat/history`, { headers });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};
//////////////////// Baccarat ////////////////////

//////////////////// FiveCardDraw ////////////////////
export const startFiveCardDraw = async (betAmount) => {
  const headers = getAuthHeaders();
  const response = await axios.post(`${API_URL}five-card-draw/start`, { betAmount }, { headers });
  return response.data;
};

export const playFiveCardDraw = async (betAmount) => {
  const headers = getAuthHeaders();
  const response = await axios.post(`${API_URL}five-card-draw/play`, { betAmount }, { headers });
  return response.data;
};

export const exchangeFiveCardDraw = async (indices) => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.post(`${API_URL}five-card-draw/exchange`, { indices }, { headers });
    console.log('Respuesta del intercambio:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error en el intercambio de cartas:', error.response ? error.response.data : error.message);
    throw error.response?.data || 'Error desconocido en el intercambio';
  }
};

export const finishFiveCardDraw = async () => {
  const headers = getAuthHeaders();
  const response = await axios.post(`${API_URL}five-card-draw/finish`, {}, { headers });
  return response.data;
};

export const getFiveCardDrawHistory = async () => {
  const headers = getAuthHeaders();
  const response = await axios.get(`${API_URL}five-card-draw/history`, { headers });
  return response.data;
};
//////////////////// FiveCardDraw ////////////////////


//////////////////// War ////////////////////
export const playWar = async (betAmount) => {
    const headers = getAuthHeaders();
    const response = await axios.post(`${API_URL}war/play`, { betAmount }, { headers });
    return response.data;
  };

export const getWarHistory = async () => {
    const headers = getAuthHeaders();
    const response = await axios.get(`${API_URL}war/history`, { headers });
    return response.data;
};
//////////////////// War ////////////////////

//////////////////// Red Dog  ////////////////////
export const playRedDog = async (betAmount) => {
    const headers = getAuthHeaders();
    const response = await axios.post(`${API_URL}red-dog/play`, { betAmount }, { headers });
    return response.data;
};

export const resolveRedDog = async (action) => {
  const headers = getAuthHeaders();
  const response = await axios.post(`${API_URL}red-dog/resolve`, { action }, { headers });
  return response.data;
};


export const getRedDogHistory = async () => {
  const headers = getAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}red-dog/history`, { headers });
    console.log('[RedDog] Historial recibido:', response.data);
    return response.data;
  } catch (error) {
    console.error('[RedDog] Error al obtener historial:', error.response?.data || error.message);
    throw error;
  }
};
//////////////////// Red Dog  ////////////////////

//////////////////// CaribbeanStudPoker  ////////////////////
// start: descuenta Ante y devuelve playerHand + dealerUpcard
export const startCaribbeanStud = async (betAmount) => {
  const headers = getAuthHeaders();
  const { data } = await axios.post(`${API_URL}caribbean-stud/start`, { betAmount }, { headers });
  return data;
};

export const resolveCaribbeanStud = async (action) => {
  const headers = getAuthHeaders();
  const { data } = await axios.post(`${API_URL}caribbean-stud/resolve`, { action }, { headers });
  return data;
};

// history
export const getCaribbeanStudHistory = async (limit = 100) => {
  const headers = getAuthHeaders();
  const { data } = await axios.get(`${API_URL}caribbean-stud/history?limit=${limit}`, { headers });
  return data;
};
//////////////////// CaribbeanStudPoker  ////////////////////

//////////////////// Póker Chino ////////////////////
export const startChinesePoker = async (betAmount) => {
  const headers = getAuthHeaders();
  const { data } = await axios.post(`${API_URL}chinese-poker/start`, { betAmount }, { headers });
  return data; // { playerCards, message }
};

export const resolveChinesePoker = async ({ front, middle, back }) => {
  const headers = getAuthHeaders();
  const { data } = await axios.post(`${API_URL}chinese-poker/resolve`, { front, middle, back }, { headers });
  return data;
};

export const getChinesePokerHistory = async (limit = 100) => {
  const headers = getAuthHeaders();
  const { data } = await axios.get(`${API_URL}chinese-poker/history?limit=${limit}`, { headers });
  return data;
};
//////////////////// Póker Chino ////////////////////

//////////////////// Card Poker ////////////////////
export const playCardPoker = async (betAmount) => {
  const headers = getAuthHeaders();
  const response = await axios.post(`${API_URL}card-poker/play`, { betAmount }, { headers });
  return response.data;
};
export const startCardPoker = async (betAmount) => {
  const headers = getAuthHeaders();
  const response = await axios.post(`${API_URL}card-poker/start`, { betAmount }, { headers });
  return response.data;
};
export const getCardPokerHistory = async () => {
  const headers = getAuthHeaders();
  const response = await axios.get(`${API_URL}card-poker/history`, { headers });
  return response.data;
};
//////////////////// Card Poker ////////////////////

// Iniciar el juego de Pai Gow Poker
export const startPaiGowPoker = async (betAmount) => {
    try {
        const headers = getAuthHeaders();
        const response = await axios.post(`${API_URL}pai-gow/start`, { betAmount }, { headers });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

//////////////////// Pai Gow Poker ////////////////////
/* =========================================================================
   PAI GOW POKER
   ========================================================================= */

export const startPaiGow = async (betAmount) => {
  const headers = getAuthHeaders();
  const res = await axios.post(`${API_URL}pai-gow/start`, { betAmount }, { headers });
  return res.data;
};

export const resolvePaiGow = async (lowHand, highHand) => {
  const headers = getAuthHeaders();
  const res = await axios.post(`${API_URL}pai-gow/resolve`, { lowHand, highHand }, { headers });
  return res.data;
};

export const cancelPaiGow = async () => {
  const headers = getAuthHeaders();
  const res = await axios.post(`${API_URL}pai-gow/cancel`, {}, { headers });
  return res.data;
};

export const getPaiGowHistory = async () => {
  const headers = getAuthHeaders();
  const res = await axios.get(`${API_URL}pai-gow/history`, { headers });
  return res.data;
};
//////////////////// Pai Gow Poker ////////////////////

//////////////////// Numeric Slot Machine ////////////////////
export const playNumericSlotMachine = async (betAmount) => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.post(`${API_URL}/numeric-slot-machine/play`, { betAmount }, { headers });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message || 'Unexpected error');
  }
};

export const getNumericSlotMachineHistory = async (userId) => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.get(`${API_URL}/numeric-slot-machine/history`, { headers });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message || 'Unexpected error');
  }
};

//////////////////// Numeric Slot Machine ////////////////////

// Jugar Golden Seven Slots
/*export const playGoldenSevenSlots = async (betAmount) => {
  try {
      const headers = getAuthHeaders();
      const response = await axios.post(`${API_URL}playGoldenSevenSlots`, { betAmount }, { headers });
      return response.data;
  } catch (error) {
      throw error.response?.data || error.message;
  }
};

export const getGoldenSevenSlotsHistory = async (userId) => {
  try {
      const headers = getAuthHeaders();
      const response = await axios.get(`${API_URL}getGoldenSevenSlotsHistory`, {
          params: { userId },
          headers
      });
      return response.data;
  } catch (error) {
      throw error.response?.data || error.message;
  }
};*/
// Golden Seven Slots
export const playGoldenSevenSlots = async (betAmount, linesActivated) => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.post(`${API_URL}golden-seven-slots/play`, { betAmount, linesActivated }, { headers });
    return response.data;
  } catch (error) {
    const msg = error.response?.data?.error || 'Error al jugar';
    throw new Error(msg);
  }
};
export const getGoldenSevenSlotsHistory = async () => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.get(`${API_URL}golden-seven-slots/history`, { headers });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};


const gameService = {
    getGameSessions,
    addGameToSession,
    getAllSessionsWithGames,
    playMenelDie,
    playMenelTwoDice,
    playMenelDuelDice,
    getPlayerHistory,
    playBullfighterOrBull,
    playBlackJack, hitBlackJack, standBlackJack, getBlackJackHistory, resumeBlackJack, abortBlackJack,
    playEuropeanBlackJack, hitEuropeanBlackJack, standEuropeanBlackJack, resumeEuropeanBlackJack, abortEuropeanBlackJack, getEuropeanBlackJackHistory,
    playBlackJackSwitch, switchBlackJackSwitch, hitBlackJackSwitch, standBlackJackSwitch, resumeBlackJackSwitch, abortBlackJackSwitch, getBlackJackSwitchHistory,
    playBaccarat, getBaccaratHistory,
    playFiveCardDraw, startFiveCardDraw, exchangeFiveCardDraw, finishFiveCardDraw, getFiveCardDrawHistory,
    playWar, getWarHistory,
    playRedDog, resolveRedDog, getRedDogHistory,
    startCaribbeanStud, resolveCaribbeanStud, getCaribbeanStudHistory,
    startChinesePoker, resolveChinesePoker, getChinesePokerHistory,
    playCardPoker, startCardPoker, getCardPokerHistory,
    startPaiGow, resolvePaiGow, cancelPaiGow, getPaiGowHistory,
    playNumericSlotMachine, getNumericSlotMachineHistory,
    playGoldenSevenSlots, getGoldenSevenSlotsHistory,
};

export default gameService;
